import cx from 'classnames';

/**
 * Gets the index of the default dropdown option
 *
 * @param {Array} options - list of options
 * @param {String} selected - default value
 */
function getDropdownDefaultOption(options, selected) {
  let defaultOption = 0;

  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    if (option && option.value === selected) {
      defaultOption = i;
      break;
    }
  }

  return defaultOption;
}

/**
 * Gets the classes for FormInput
 *
 * @param  {String}  [inputClassModifier] - class modifier
 * @param  {Boolean} [isHidden] - is input hidden
 * @return {String}
 */
function getFormInputClasses(inputClassModifier, isHidden) {
  let classModifiers = '';

  if (inputClassModifier && inputClassModifier instanceof Array) {
    const classes = inputClassModifier.map(className => {
      return `FormInput--${className}`;
    });
    classModifiers = classes.join(' ');
  } else if (inputClassModifier) {
    classModifiers = `FormInput--${inputClassModifier}`;
  }

  return cx({
    'FormInput': true,
    'u-hide': isHidden,
  }, classModifiers);
}

/**
 * @param {Number} errorLeft - left position or error message relative to window
 */
function setErrorWidth(errorLeft) {
  const winWidth = window.innerWidth;
  return winWidth - errorLeft - 20;
}

/**
 * Validates frequent flyer number using the Luhn algorithm and creditcards
 * @param  {String} num - Frequent flyer number
 * @return {Boolean}  does this number validate
 */
function verifyWithLuhnAlgorithm(num) {
  // También valida AEROMAR
  if (!num) return false;

  const acc = num.split('').reverse().join('');
  let accSum = 0;

  for (let i = 0; i !== acc.length; i++) {
    let digit = parseInt(acc[i], 10);

    if (!((i + 1) % 2)) {
      digit = digit * 2;
      if (digit > 9) {
        let sum = 0;
        while (digit > 0) {
          sum += digit % 10;
          digit = Math.floor(digit / 10);
        }
        digit = sum;
      }
    }

    accSum += digit;
  }

  return accSum % 10 === 0;
}

/**
 * Validates frequent flyer number using the Luhn algorithm
 * @param  {String} num - Frequent flyer number
 * @return {Boolean}     does this number validate
 */
function verifyClubPremierNumber(num) {
  // También valida AEROMAR
  if (!num) return false;

  const acc = num.split('').reverse().join('');
  let accSum = 0;

  for (let i = 0; i !== acc.length; i++) {
    let digit = parseInt(acc[i], 10);

    if (!((i + 1) % 2)) {
      digit = digit * 2;
      if (digit > 9) {
        let sum = 0;
        while (digit > 0) {
          sum += digit % 10;
          digit = Math.floor(digit / 10);
        }
        digit = sum;
      }
    }

    accSum += digit;
  }

  return accSum % 10 === 0;
}

/**
 * When user changes address country from MX --> US/CA, we switch the input from
 * text field to a dropdown. This function takes the value from the text input and
 * tests to see if it exists in the states array, in which case it returns the index.
 *
 * @param {String} value - state text input value
 * @param {Array} states - state dropdown options
 * @return {Number} index of state
 */
function getStateIndexFromTextInputValue(value, states) {
  if (!value || (value.length < 2 && value.length > 3)) {
    return 0;
  }

  const i = states.findIndex(state => {
    return state.value === value;
  });

  return i > -1 ? i : 0;
}

// capitalize the first letter in the name
function nameFirstLetterUpperCase(inputName) {
  const nameArr = inputName.split(' ') ;
  for (let i = 0 ; i < nameArr.length ; i++) {
    nameArr[i] = nameArr[i].charAt(0).toUpperCase() + nameArr[i].slice(1).toLowerCase() ;
  }
  return (nameArr.join(' ')) ;
}

function consecutiveDigits(num) {
  const patron = /(\d)\1/;
  return !patron.test(num);
}

function checkIsCountryEU(countryCode) {
  const countryCodeListEU = ['DE', 'AT', 'BE', 'BG', 'CY', 'HR', 'DK', 'SI', 'SK', 'ES', 'EE', 'FI', 'FR', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'CZ', 'RO', 'SE'];
  return (countryCodeListEU.includes(countryCode)) ;
}

export {
  getDropdownDefaultOption,
  getFormInputClasses,
  getStateIndexFromTextInputValue,
  setErrorWidth,
  verifyClubPremierNumber,
  verifyWithLuhnAlgorithm,
  nameFirstLetterUpperCase,
  consecutiveDigits,
  checkIsCountryEU,
};
